import type { ExternalMediaProviderPolicy } from "./ExternalMediaTypes";

const EXTERNAL_MEDIA_PROVIDER_POLICIES: readonly ExternalMediaProviderPolicy[] = [
    {
        nodeType: "youtube",
        providerId: "youtube",
        displayName: "YouTube",
        renderKind: "iframe",
        allowedInDiscussion: true,
        allowedInArgument: false,
        isAdultProvider: false,
        isSensitiveByDefault: false,
        fallbackBehavior: "linkCard",
    },
    {
        nodeType: "linkCard",
        providerId: "linkCard",
        displayName: "Link card",
        renderKind: "linkCard",
        allowedInDiscussion: true,
        allowedInArgument: false,
        isAdultProvider: false,
        isSensitiveByDefault: false,
        fallbackBehavior: "linkCard",
    },
    {
        nodeType: "pornHub",
        providerId: "pornHub",
        displayName: "Pornhub",
        renderKind: "iframe",
        allowedInDiscussion: true,
        allowedInArgument: false,
        isAdultProvider: true,
        isSensitiveByDefault: true,
        fallbackBehavior: "linkCard",
    },
    {
        nodeType: "redGifs",
        providerId: "redGifs",
        displayName: "RedGifs",
        renderKind: "iframe",
        allowedInDiscussion: true,
        allowedInArgument: false,
        isAdultProvider: true,
        isSensitiveByDefault: true,
        fallbackBehavior: "linkCard",
    },
] as const;

const externalMediaProviderPolicyMap = new Map<string, ExternalMediaProviderPolicy>(
    EXTERNAL_MEDIA_PROVIDER_POLICIES.map((policy) => [policy.nodeType, policy]),
);

export function getExternalMediaProviderPolicies(): readonly ExternalMediaProviderPolicy[] {
    return EXTERNAL_MEDIA_PROVIDER_POLICIES;
}

export function getExternalMediaProviderPolicy(nodeType: string | null | undefined): ExternalMediaProviderPolicy | undefined {
    if (typeof nodeType !== "string") {
        return undefined;
    }

    return externalMediaProviderPolicyMap.get(nodeType);
}

const EXTERNAL_MEDIA_NODE_NAMES: readonly string[] = Object.freeze(
    EXTERNAL_MEDIA_PROVIDER_POLICIES.map((policy) => policy.nodeType),
);

const ADULT_EXTERNAL_MEDIA_NODE_NAMES: readonly string[] = Object.freeze(
    EXTERNAL_MEDIA_PROVIDER_POLICIES.filter((policy) => policy.isAdultProvider).map((policy) => policy.nodeType),
);

export function getExternalMediaNodeNames(): readonly string[] {
    return EXTERNAL_MEDIA_NODE_NAMES;
}

export function getAdultExternalMediaNodeNames(): readonly string[] {
    return ADULT_EXTERNAL_MEDIA_NODE_NAMES;
}
